import React from 'react';

import type { IconProps } from '../../icon-types';
import { IconBase } from '../../IconBase';

export const LockIcon = React.forwardRef<SVGSVGElement, IconProps>(function LockIcon(props, ref) {
    return (
        <IconBase ref={ref} viewBox="0 0 24 24" {...props}>
            <path fill="currentColor" d="M18 8.5h-1v-2a5 5 0 0 0-10 0v2H6a2 2 0 0 0-2 2v10c0 1.1.9 2 2 2h12a2 2 0 0 0 2-2v-10a2 2 0 0 0-2-2m-6 9c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2m3.1-9H8.9v-2a3.1 3.1 0 0 1 6.2 0z"/>
        </IconBase>
    );
});
